import classNames from 'classnames';
import { FC, memo } from 'react';
import styles from './BoldLabelText.module.scss';

const cx = classNames.bind(styles);

export type Props = {
  children: React.ReactNode;
};

export const BoldLabelText: FC<Props> = memo(({ children }) => {
  return <div className={cx(styles['label-bold'])}>{children}</div>;
});

BoldLabelText.displayName = 'BoldLabelText';
